import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import TeacherHeader from './components/TeacherHeader';
import Dashboard from './components/Dashboard';
import MyCourses from './components/MyCourses';
import Students from './components/Students';
import Assignments from './components/Assignments';
import Schedule from './components/Schedule';

export default function Teacher() {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [userProfile, setUserProfile] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const initializeUser = async () => {
      try {
        setLoading(true);
        
        // Lấy email từ localStorage
        const userEmail = localStorage.getItem('userEmail');
        console.log('User email from localStorage:', userEmail);
        
        if (!userEmail) {
          console.error('No user email found');
          navigate('/login');
          return;
        }

        // Thử lấy từ userProfile trước
        let profile = null;
        try {
          const storedProfile = localStorage.getItem('userProfile');
          if (storedProfile) {
            profile = JSON.parse(storedProfile);
            console.log('Profile from localStorage:', profile);
          }
        } catch (e) {
          console.error('Error parsing stored profile:', e);
        }

        // Nếu không có profile hoặc email không khớp, tạo profile từ email
        if (!profile || profile.email !== userEmail) {
          // Tạo profile từ email đăng nhập
          const nameFromEmail = userEmail.split('@')[0];
          const displayName = nameFromEmail.charAt(0).toUpperCase() + nameFromEmail.slice(1);
          
          profile = {
            id: `teacher_${Date.now()}`,
            email: userEmail,
            full_name: displayName,
            user_type: 'teacher',
            avatar_url: null,
            phone: '',
            bio: '',
            created_at: new Date().toISOString()
          };
          
          // Lưu profile mới
          localStorage.setItem('userProfile', JSON.stringify(profile));
          console.log('Created new profile:', profile);
        }

        setUserProfile(profile);
        
        // Lưu thông tin user để các component khác sử dụng
        localStorage.setItem('user', JSON.stringify(profile));
        
      } catch (error) {
        console.error('Error initializing user:', error);
        navigate('/login');
      } finally {
        setLoading(false);
      }
    };

    initializeUser();
  }, [navigate]);

  const handleProfileUpdate = (updatedProfile: any) => {
    setUserProfile(updatedProfile);
    localStorage.setItem('userProfile', JSON.stringify(updatedProfile));
    localStorage.setItem('user', JSON.stringify(updatedProfile));
  };

  const handleSwitchToAssignments = () => {
    setActiveTab('assignments');
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="flex items-center space-x-2 text-gray-500">
          <i className="ri-loader-4-line animate-spin text-xl"></i>
          <span>Đang tải thông tin giáo viên...</span>
        </div>
      </div>
    );
  }

  if (!userProfile) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <i className="ri-error-warning-line text-4xl text-red-500 mb-4"></i>
          <h2 className="text-xl font-semibold text-gray-900 mb-2">Không thể tải thông tin giáo viên</h2>
          <p className="text-gray-600 mb-4">Vui lòng đăng nhập lại</p>
          <button
            onClick={() => navigate('/login')}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            Đăng nhập lại
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <TeacherHeader 
        userProfile={userProfile} 
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        onProfileUpdate={handleProfileUpdate}
      />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Remove duplicate navigation tabs - already in header */}
        
        {/* Tab Content */}
        <div className="space-y-6">
          {activeTab === 'dashboard' && <Dashboard userProfile={userProfile} />}
          {activeTab === 'courses' && (
            <MyCourses 
              userProfile={userProfile} 
              onSwitchToAssignments={handleSwitchToAssignments}
            />
          )}
          {activeTab === 'students' && <Students userProfile={userProfile} />}
          {activeTab === 'assignments' && <Assignments userProfile={userProfile} />}
          {activeTab === 'schedule' && <Schedule userProfile={userProfile} />}
        </div>
      </div>
    </div>
  );
}
